import React from 'react'
import Visitorform from './Visitorform'

export const Enquiry = () => {
  return (
    <div>
        
        <section id="map" className="services">
        <div className="row">
        <div className="col-12">
              <div className="title text-center">
                <h2>Enquiry Here</h2>
              </div>
            </div>
          <div className="col-md-1"></div>
          <div className="col-md-5" id="iframe">
            <iframe
              title="/"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.3618744065498!2d73.7527011148933!3d18.557717187387397!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2bf1a60111fed%3A0x1e033293b6224669!2sMacrozion%20Techsystem%20Private%20Limited!5e0!3m2!1sen!2sin!4v1633078159489!5m2!1sen!2sin"
              width="500"
              height="400"
              frameborder="0"
              style={{ border: 0 }}
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></iframe>
          </div>

          <Visitorform />
        </div>
      </section>
    </div>
  )
}
